var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("SoliForm", {
        ref: "form",
        attrs: {
          title: `Assign to ${_vm.getRoom.title}`,
          text: "Add to Room",
          icon: "save",
          hideBtn: !!_vm.availConflict,
          saveChanges: _vm.saveChanges,
          textSubtitle: _vm.form.avail
            ? _vm.form.avail.recurrence
              ? `${_vm.globalMomentDate(_vm.form.avail.starts_at)} ${
                  _vm.form.avail.recurrence.ends_at
                    ? `until ${_vm.globalMomentDate(
                        _vm.form.avail.recurrence.ends_at
                      )}`
                    : `· Weekly on ${_vm.globalMomentWeekDay(
                        _vm.form.avail.starts_at
                      )}s`
                }`
              : null
            : null,
        },
        on: { submit: _vm.submit, reset: _vm.reset },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("v-select", {
                  attrs: {
                    items: _vm.assignToday
                      .map((avail) => {
                        return {
                          id: avail.id,
                          teacher: avail.teacher,
                          user_id: avail.teacher.id,
                          recurrence: avail.recurrence,
                          removed_from_series: avail.removed_from_series,
                          starts_at: avail.starts_at,
                          online_only: avail.online_only,
                          ends_at: avail.ends_at,
                          name: `${avail.teacher.name}: 
                                ${_vm.globalMomentTime(
                                  avail.starts_at
                                )} to ${_vm.globalMomentTime(avail.ends_at)}`,
                        }
                      })
                      .filter((e) =>
                        _vm.getRoom.extendedProps.user_id
                          ? e.user_id == _vm.getRoom.extendedProps.user_id &&
                            e.online_only
                          : !e.online_only
                      ),
                    "item-text": "name",
                    "item-value": "id",
                    label: _vm.label,
                    "hide-details": "",
                    "return-object": "",
                    outlined: "",
                    dense: "",
                    disabled: _vm.disabled,
                    rules: [(v) => !!v || "Item is required"],
                  },
                  on: { input: _vm.checkConflicts },
                  model: {
                    value: _vm.form.avail,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "avail", $$v)
                    },
                    expression: "form.avail",
                  },
                }),
                _vm._v(" "),
                _vm.availConflict
                  ? _c("SoliChoice", {
                      attrs: {
                        title: "Hey!",
                        subtitle: `This availability ends on ${_vm.globalMomentDate(
                          _vm.availConflict
                        )}. Would you like to assign ${
                          _vm.form.avail.teacher.first_name
                        } until then?`,
                        button1: "Ok",
                      },
                      on: {
                        reset: function ($event) {
                          _vm.availConflict = null
                        },
                        option1: function ($event) {
                          ;[(_vm.form.recurrence_end = _vm.availConflict)]
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.availabilityRemovedFromSeries
                  ? _c("SoliChoice", {
                      attrs: {
                        title: "Heads up!",
                        subtitle: `This availability was removed from its recurring series. This assignment will only be scheduled for ${_vm.globalMomentDate(
                          _vm.form?.avail?.starts_at
                        )}. Do you want to continue?`,
                        button1: "Ok",
                        button2: "Nevermind",
                        persistent: "",
                      },
                      on: {
                        reset: function ($event) {
                          ;[
                            (_vm.availabilityRemovedFromSeries = null),
                            _vm.form.confirmedRemovedFromSeries
                              ? null
                              : (_vm.form.avail = null),
                          ]
                        },
                        option1: function ($event) {
                          _vm.form.confirmedRemovedFromSeries = true
                        },
                        option2: function ($event) {
                          _vm.form.avail = null
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.futureConflict
                  ? _c("SoliChoice", {
                      attrs: {
                        title: "Uh oh",
                        subtitle: `${
                          _vm.futureConflict.roomConflict
                            ? _vm.futureConflict.roomConflict
                            : _vm.form.avail.teacher.first_name
                        } is already assigned at this time, starting ${_vm.globalMomentDate(
                          //conflicts[0].starts_at
                          new Date(
                            _vm.futureConflict.date ??
                              JSON.parse(_vm.futureConflict[0])?.starts_at
                          )
                        )}. Would you like to schedule ${
                          _vm.form.avail.teacher.first_name
                        } until then?`,
                        button1: "Ok",
                        button2: "Nevermind",
                        persistent: "",
                      },
                      on: {
                        option1: function ($event) {
                          ;(_vm.form.recurrence_end = _vm.futureConflict.date),
                            (_vm.futureConflict = null),
                            (_vm.form.noConflict = true),
                            (_vm.$refs.form.loading = true),
                            _vm.submit()
                        },
                        option2: function ($event) {
                          ;[
                            (_vm.form.noConflict = false),
                            (_vm.$refs.form.loading = false),
                          ]
                        },
                        reset: function ($event) {
                          _vm.futureConflict = null
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.roomConflicts /*|| teacherConflicts*/
                  ? _c("div", { staticClass: "px-3" }, [
                      _vm.roomConflicts && _vm.openRoomTimes.length
                        ? _c("div", { staticClass: "mb-2" }, [
                            _c("small", { staticClass: "red--text" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    `· ${_vm.roomConflicts.room.title} has conflicts. Please select an open time within ${_vm.getTeacher}'s availability.`
                                  ) +
                                  "\n                    "
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.roomUnavailable
                        ? _c("div", { staticClass: "mb-2" }, [
                            _c("small", { staticClass: "red--text" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    `· ${_vm.roomConflicts.room.title} is not available during ${_vm.getTeacher}'s availability.`
                                  ) +
                                  "\n                    "
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.openRoomTimes.length
                  ? _c(
                      "v-btn-toggle",
                      {
                        staticClass: "mb-2",
                        staticStyle: { width: "100%" },
                        attrs: { dense: "" },
                        model: {
                          value: _vm.selectedOpening,
                          callback: function ($$v) {
                            _vm.selectedOpening = $$v
                          },
                          expression: "selectedOpening",
                        },
                      },
                      [
                        _c(
                          "v-row",
                          { staticClass: "pa-6" },
                          _vm._l(_vm.openRoomTimes, function (time) {
                            return _c(
                              "v-btn",
                              {
                                key: time.start,
                                staticClass: "soli-blue-text rounded-pill my-2",
                                attrs: {
                                  dense: "",
                                  block: "",
                                  outlined: "",
                                  value: time,
                                },
                              },
                              [_vm._v(_vm._s(`${time.start} to ${time.end}`))]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }